import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type Props = {
  totalNumber: number
  roomNumber: string
  onClose: () => void
}
export const RoomToIssueKeyModal: React.FC<Props> = props => {
  const { t } = useTranslation()

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      props.onClose()
    }, 2000)
    return () => clearTimeout(timeoutId)
  }, [])

  return (
    <>
      <div css={modalBgStyle}></div>
      <div css={modalStyle}>
        <div className="issue-announce-text">{t('SelfCheckIn.CardIssueAnnouncement', { n: props.totalNumber })}</div>
        <div className="room-block">
          <div className="room-number-label">{t('Room number')}</div>
          <div className="room-number-text">{props.roomNumber}</div>
        </div>
      </div>
    </>
  )
}

const modalBgStyle = css({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 100,
  background: 'rgba(39, 39, 39, 0.5)',
  width: '100%',
  height: '100%',
})
const modalStyle = css(
  {
    position: 'fixed',
    zIndex: 1000,
    background: '#ffffff',
    boxSizing: 'border-box',
    borderRadius: 10,
    width: 600,
    // top/bottomを0にした中央寄せのため、height未指定だと縦いっぱいに引き伸ばされる
    height: 'fit-content',
    minHeight: 322,
    maxHeight: '100%',
    overflowY: 'auto',
    margin: 'auto',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    lineHeight: 1.5,
    padding: 40,
    textAlign: 'center',
    '.issue-announce-text': {
      minHeight: 33,
      fontSize: 24,
      lineHeight: '33px',
      fontWeight: 'bold',
      color: '#272727',
      letterSpacing: 1.2,
    },
    '.room-block': {
      marginTop: 24,
      boxSizing: 'border-box',
      minHeight: 183,
      padding: '30px 0 31px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: '#F2F2F2',
      border: '2px solid #CCCCCC',
      borderRadius: 10,
      '.room-number-label': {
        width: '100%',
        minHeight: 29,
        fontSize: 21,
        lineHeight: '29px',
        fontWeight: 'bold',
        color: '#676767',
        letterSpacing: 1.05,
      },
      // 1行に収まらない部屋番号でも行送りが間延びしないよう、行の高さはminHeightで担保して行間は倍率で持たせる
      '.room-number-text': {
        width: '100%',
        minHeight: 82,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 7,
        fontSize: 60,
        lineHeight: 1.2,
        fontWeight: 'bold',
        color: '#F2A40B',
        letterSpacing: 3,
        wordBreak: 'break-word',
      },
    },
  },
  createSelfCheckinResponsiveStyle({
    portrait: { '.room-block .room-number-text': { fontSize: 61, letterSpacing: 3.05 } },
  }),
)
